import React from 'react';

const Privacy = () => {
  return (
    <div className="legal-page">
      <section className="hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>We protect personal and business data with transparent handling practices.</p>
        </div>
      </section>
      <section className="section">
        <div className="container legal-content">
          <h2>Data We Collect</h2>
          <p>Contact form inputs, service requests, and website analytics necessary to improve services.</p>
          <h2>How We Use Data</h2>
          <p>To respond to inquiries, deliver services, improve performance, and maintain security.</p>
          <h2>Your Rights</h2>
          <p>You can request access, correction, or deletion by contacting privacy@msatechnologies.com.</p>
        </div>
      </section>
    </div>
  );
};

export default Privacy;

